import { MediaMatcher } from "@angular/cdk/layout";
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { MenuItems } from "../../shared/menu-items/menu-items";
import { Router } from "@angular/router";
import { AuthService } from "src/app/giz-library/auth/service/auth.service";
import { UserService } from "src/app/giz-library/user/service/user.service";

/** @title Responsive sidenav */
@Component({
  selector: "app-full-layout",
  templateUrl: "full.component.html",
  styleUrls: ["./full.component.css"],
})
export class FullComponent implements OnDestroy, AfterViewInit {
  mobileQuery: MediaQueryList;

  cookiePolicyLink = "Política de cookies";
  cookiePolicyHref = "/policy-a";
  privacyPolicyLink = "Política de privacidad";
  privacyPolicyHref = "/policy-b";
  tosLink = "Términos de servicio";
  tosHref = "/policy-c";

  private _mobileQueryListener: () => void;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private authService: AuthService,
    private userService: UserService,
    public menuItems: MenuItems,
    private router: Router,
  ) {
    this.mobileQuery = media.matchMedia("(min-width: 768px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  goToView(url: string) {
    window.open(url, "_blank");
  }

  navigateToView(view: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(["/", view]).then(() => {
      })
    })
  }

  scrollRestoration(): void {
    document.getElementsByClassName("head")[0].scrollIntoView();
  }

  isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  fnGoToView(_route: string, _have_params: boolean = false) {
    if (_have_params) {
      const _user_id = this.authService.getUserId();
      this.userService.getUserById(_user_id).subscribe(
        (x: any) => {
          const _params = {
            p_user_id: _user_id,
            p_username: x.data.username
          };
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([_route], {
              queryParams: _params
            }).then(() => {
            })
          });
        }
      );
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([_route]).then(() => {
        })
      })
    }
  }

}